import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { useState } from 'react';
import styled from 'styled-components';
import { Flex } from '../../Utils/styles/display';
import Theme from '../../theme';
import Body from '../atoms/Body';
import ToggleSwitch from '../atoms/ToggleSwitch';
import { SwitchTextTypes } from '../atoms/ToggleSwitch/types';
import { useMediaQuery } from 'react-responsive';
import { device } from '../../constants/layout';
import { zIndexOptInBanner } from '../../Utils/styles/z-index';

const OptInBannerContainer = styled(Flex)`
  background-color: ${Theme.palette.geekBlue2};
  width: 100vw;
  padding: 10px 16px;
  top: 0;
  position: fixed;
  z-index: ${zIndexOptInBanner};
`;

const StarIcon = styled(StarOutlineIcon)`
  color: ${Theme.palette.geekBlue6};
`;

export function OptInBanner({ onOptIn }: { onOptIn: () => void }) {
  const [isOn, setIsOn] = useState(false);
  const isMobileView = useMediaQuery({
    query: device.mobile,
  });

  return (
    <OptInBannerContainer justifyContent="space-between" alignItems="center">
      <Flex gap="4px">
        <StarIcon fontSize="small" />
        <Body variant="body2Bold">Try new Assembly Experience</Body>
        {!isMobileView && (
          <Body variant="body2">
            Get important updates in real time, more customized to you.
          </Body>
        )}
      </Flex>

      <Flex gap="4px">
        {!isMobileView && (
          <Body variant="body2">Try new Assembly Experience</Body>
        )}
        <ToggleSwitch
          id="opt-in-banner-switch"
          textType={SwitchTextTypes.EMPTY}
          isOn={isOn}
          onChange={() => {
            setIsOn(!isOn);
            onOptIn();
          }}
        />
      </Flex>
    </OptInBannerContainer>
  );
}
